import React from 'react';
import './App.css';
import './theme.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from 'react-toastify';

import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';

// Layouts
import NavHeader from './Components/Layout/NavHeader';
import FooterSection from './Components/Layout/Footer';
import ContactLayout from './Components/Layout/Contact/ContactLayout';
import AdminLayout from './Components/Layout/Admin/AdminLayout';
import CoordinatorLayout from './Components/Layout/coordinator/CoordinatorLayout';

// Home Components
import HeroSection from './Components/HomeComponents/HeroSection';
import ServicesSection from './Components/HomeComponents/Services';
import SuccessStoriesSection from './Components/HomeComponents/SuccessStories';
import IndustryAISolutions from './Components/HomeComponents/Solutions';
import AboutSection from './Components/HomeComponents/About';
import FeesworthContact from './Components/HomeComponents/FeesworthContact';

// Pages
import { LoginPage } from './Pages/login/LoginPage';
import EnquiryFormPage from './Pages/EnqForm/EnquiryFormPage';
import Logout from './Pages/login/Logout';

// Admin Pages
import Dashboard from './Pages/Admin/Dashboard';
import PerformanceDetails from './Pages/Admin/PerformanceDetails';
import AdminEnquiries from './Pages/Admin/AdminEnquires';
import AdminEnquiryDetails from './Pages/Admin/AdminEnquiryDetails';
import AdminUsers from './Pages/Admin/user/AdminUser';
import Feescollection from './Pages/Admin/Feescollection';
import Activitylog from './Pages/Admin/Activitylog';

// Coordinator Pages
import CoordinatorDashboard from './Pages/coordinator/CoordinatorDashboard';
import MyEnquiries from './Components/Layout/coordinator/MyEnquiries';
import EnquiryDetails from './Components/Layout/coordinator/EnquiryDetails';
import AllEnquiries from './Components/Layout/coordinator/AllEnquiries';
import MyFollowUps from './Components/Layout/coordinator/MyFollowUps';
import FeesCollection from './Components/Layout/coordinator/FeesCollection';

// Common
import BatchManagement from './Pages/Batch/BatchManagement';

// Auth Routes
import ProtectedRoute from './Routes/ProtectedRoute';
import RoleRoute from './Routes/RoleRoute';
import Contactform from './Pages/WoconsContact/Contactform';
import ContactList from './Pages/Admin/ContactList';

// ✅ Home Component
function Home() {
  return (
    <>
      <div id="hero-section"><HeroSection /></div>
      <div id="services-section"><ServicesSection /></div>
      <div id="success-stories-section"><SuccessStoriesSection /></div>
      <div id="solutions-section"><IndustryAISolutions /></div>
      <div id="about-section"><AboutSection /></div>
    </>
  );
}

// ✅ Main Layout (Default Website Header)
const MainLayout = () => {
  return (
    <>
      <NavHeader />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/feesworth" element={<FeesworthContact />} />
      </Routes>
      <FooterSection />
    </>
  );
};

// ✅ App Component
function App() {
    const location = useLocation();
  return (
    <>
      <ThemeProvider>
        <AuthProvider>
          <ToastContainer position="bottom-right" autoClose={3000} />

          {/* ✅ Header Control */}
          {location.pathname === "/feesworth-contact" 
            ? null   // ❌ hide default header
            : <NavHeader />  // ✅ show for all other pages
          }

          <Routes>

            {/* 🌐 Public Website */}
            <Route path="/" element={
              <>
                <Home />
                <FooterSection />
              </>
            } />

            <Route path="/feesworth" element={<FeesworthContact />} />

            {/* 📞 Contact Page (Custom Header inside layout) */}
            <Route element={<ContactLayout />}>
              <Route path="/feesworth-contact" element={<EnquiryFormPage />} />
            </Route>

            {/* 🔐 Auth */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/contact" element={<Contactform />} />

            {/* 🔐 Admin */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <RoleRoute allowedRole="Admin">
                    <AdminLayout />
                  </RoleRoute>
                </ProtectedRoute>
              }
            >
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="performance/:name" element={<PerformanceDetails />} />
              <Route path="enquiries" element={<AdminEnquiries />} />
              <Route path="enquiries/:eid" element={<AdminEnquiryDetails />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="fees" element={<Feescollection />} />
              <Route path="logs" element={<Activitylog />} />
              <Route path="batch" element={<BatchManagement />} />
              <Route path="contactlist" element={<ContactList />} />
            </Route>

            {/* 🔐 Coordinator */}
            <Route
              path="/coordinator"
              element={
                <ProtectedRoute>
                  <RoleRoute allowedRole="Coordinator">
                    <CoordinatorLayout />
                  </RoleRoute>
                </ProtectedRoute>
              }
            >
              <Route path="dashboard" element={<CoordinatorDashboard />} />
              <Route path="enquiries" element={<MyEnquiries />} />
              <Route path="all-enquiries" element={<AllEnquiries />} />
              <Route path="enquiries/:eid" element={<EnquiryDetails />} />
              <Route path="followups" element={<MyFollowUps />} />
              <Route path="fees" element={<FeesCollection />} />
              <Route path="batch" element={<BatchManagement />} />
            </Route>

          </Routes>
        </AuthProvider>
      </ThemeProvider>
    </>
  );
}

export default App;